import { __assign, __rest } from "tslib";
import * as React from 'react';
import { useToggleIndices } from '../../hooks/useToggleIndices';
import { toggleAccordionEvent } from './constants';
/**
 * Represents an accordion.
 */
export var AccordionContainer = function (_a) {
    var children = _a.children, multiple = _a.multiple, props = __rest(_a, ["children", "multiple"]);
    var container = React.useRef(null);
    var _b = useToggleIndices(multiple), openIndices = _b[0], toggle = _b[1];
    React.useEffect(function () {
        var element = container.current;
        if (element) {
            var handler_1 = function (ev) {
                var index = ev.detail.index;
                toggle(index);
            };
            element.addEventListener(toggleAccordionEvent, handler_1);
            return function () { return element.removeEventListener(toggleAccordionEvent, handler_1); };
        }
    }, [multiple]);
    return (React.createElement("ul", __assign({}, props, { className: "accordion", ref: container }), React.Children.map(children, function (child, i) { return (React.createElement("li", { key: i, className: openIndices.includes(i) ? 'accordion-open' : 'accordion-closed' }, child)); })));
};
//# sourceMappingURL=AccordionContainer.js.map